import { Button, Form, Input, Modal, Typography } from 'antd'
import cryptoRandomString from 'crypto-random-string'
import React, { useEffect } from 'react'
import { useLocation } from 'react-router-dom'
import Logo from '../../images/pejlen_liggande.svg'
import '../../styles/app.css'
import { useFinalizeTempUser } from './hooks/registerUser'

const NewUser: React.FC = () => {
  return (
    <div>
      <div className="w-[150px] p-4">
        <img src={Logo} alt="Inrikta logga" width={'100%'} />
      </div>
      <div className="gap 4 max-w-s mx-auto mt-32 flex h-full flex-col items-center">
        <NewUserForm />
      </div>
    </div>
  )
}

const NewUserForm = () => {
  const location = useLocation()

  const params = new URLSearchParams(location.search)

  const name = params.get('name')
  const { mutate: finalizeUser, data } = useFinalizeTempUser()

  const onFinish = async (values: any) => {
    try {
      finalizeUser({ personnummer: values.personnummer })
    } catch (e) {
      console.error(e)
    }
  }

  useEffect(() => {
    if (!data) return

    if (data.success) {
      // Redirect to redirect_to
      console.log('Redirecting to', data.redirect_to)
      window.location.href = data.redirect_to
      return
    }

    // Login user again
    const state = cryptoRandomString({ length: 32 })
    localStorage.setItem('oauth2_authentication_csrf', state)
    const hydra_url = process.env.REACT_APP_HYDRA_URL
    window.location.href = `${hydra_url}/oauth2/auth?client_id=${data.client_id}&response_type=code&scope=offline%20openid&state=${state}&login_hint=saml`
  }, [data])

  return (
    <Modal open={true} footer={false} closable={false}>
      <div className="flex flex-col gap-4">
        Välkommen till Pejlen {name}! <br />
        För att vi ska kunna visa dig relevant information och rätt vyer behöver vi ditt personnummer. Din information hanteras säkert och används enbart för detta syfte. <br /> Om du skulle uppleva
        problem med Pejlen, eller om du har några frågor, hör du av dig till någon/några av kommunens Superusers. Alternativt mailar du till oss på inRikta genom support@inrikta.se eller
        anton.johansson@inrikta.
        <div className="flex max-w-xs flex-col gap-4">
          <Form name="new-user" autoComplete="off" layout="vertical" onFinish={onFinish}>
            <Form.Item
              label="Personnummer"
              name="personnummer"
              rules={[
                {
                  required: true,

                  validator: (rule, value) => {
                    if (!value.match(/^[0-9]{8}-[0-9]{4}$/)) {
                      return Promise.reject('Vänligen fyll i personnummer i formatet ÅÅÅÅMMDD-XXXX')
                    }
                    return Promise.resolve()
                  },
                },
              ]}
            >
              <Input type="text" placeholder="ÅÅÅÅMMDD-XXXX" />
            </Form.Item>
            <Button type="primary" htmlType="submit" style={{ width: '50%' }}>
              Spara & Logga in
            </Button>
          </Form>
        </div>
      </div>
    </Modal>
  )
}

export default NewUserForm
